var map = {
	"./alimentos-y-bebidas.jpg": 1464,
	"./automotriz.jpg": 4112,
	"./belleza-y-cuidado-personal.jpg": 4180,
	"./deportes-y-entretenimiento.jpg": 4812,
	"./electronica.jpg": 1156,
	"./electronicos-para-el-hogar.jpg": 2432,
	"./hogar-y-jardin.jpg": 8364,
	"./juguetes-y-pasatiempos.jpg": 8624,
	"./moda.jpg": 5804,
	"./salud-y-cuidado-personal.jpg": 2476
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8384;